<template>
    <div>
        <p v-if="isDisabled" class="font-weight-bold text-color">
            {{ getSubText }}
        </p>
        <div class="d-flex flex-row flex-wrap w-100">
            <TextInput
                type="text"
                name="emailInput"
                :has-error="hasError"
                :current-error="errorMessage"
                v-model="email"
                label="me@example.edu"
                class="mr-3 w-75"
                icon="far fa-envelope"
                :disabled="isDisabled"
            ></TextInput>

            <ButtonWithLoadingState
                :text="translate('Get Started')"
                class="pr-4 font-weight-bold text-white btn btn-lg btn-success align-self-center text-uppercase mt-sm-0"
                :is-state-loading="isSubmitting"
                @click="submitForValidation"
                @keyup.enter="submitForValidation"
                :disabled="isUserEducational || isDisabled"
            ></ButtonWithLoadingState>
        </div>
    </div>
</template>

<script>
import TextInput from '../form/TextInput.vue';
import TransFilter from '../mixins/TransFilter.vue';
import ButtonWithLoadingState from '../form/ButtonWithLoadingState.vue';
import { translate } from '../../../../helper/translate';
import { apiRequestManager } from '../../../../../lib-sat/api/api-request-manager';
import { pageNotification } from '../../../../helper/notify';
import { testIsEmailValid } from '../../../../../lib-sat/user/test';
import { registerPaymentModalHelper } from '../../../../../lib-sat/user/modal/register_payment_flow/register-payment-modal-helper';
import { pageStoreMixin } from '../../../../../lib-sat/store/page-store';
import { eventBus } from '../../../../../lib/event-bus/event-bus';
import { CONTACT_US_OPEN_MODAL } from '../../../../../lib-sat/contact-us/event';
import { userManager } from '../../../../../lib-sat/user/user-manager';
import { satGlobals } from '../../../../sat/helper/sat-globals';

export default {
    name: 'EducationValidation',
    components: { ButtonWithLoadingState, TextInput },
    mixins: [TransFilter, ButtonWithLoadingState, pageStoreMixin],
    async mounted() {
        const user = await userManager.getUser();
        this.isUserEducational = user.isEducational();
        if (user.isRegistered() === true) {
            this.isDisabled = true;
        }
    },
    methods: {
        async submitForValidation() {
            this.hasError = false;
            this.isSubmitting = true;

            if (!testIsEmailValid(this.email)) {
                this.hasError = true;
                this.errorMessage = translate('E-Mail is not valid');
                this.isSubmitting = false;
                return;
            }

            const endpoint = `/api/users/education/validate/${this.email}`;

            try {
                const response = await apiRequestManager.get(endpoint);
                if (response.data === 'true') {
                    this.store.userPaymentModal.setSkipPayment(true);
                    this.store.userPaymentModal.setEmail(this.email);
                    registerPaymentModalHelper.openRegister();
                } else {
                    eventBus.emit(CONTACT_US_OPEN_MODAL, { education: true });
                }
            } catch (e) {
                pageNotification.showGenericErrorMessage();
            } finally {
                this.isSubmitting = false;
            }
        },
    },
    data() {
        return {
            email: '',
            isSubmitting: false,
            hasError: false,
            errorMessage: '',
            isUserEducational: false,
            isDisabled: false,
        };
    },
    computed: {
        getStartedText() {
            return translate('Get started');
        },
        getSubText() {
            return translate('In order to apply for %project% education you need to logout first.', {
                '%project%': satGlobals.getProjectName(),
            });
        },
    },
};
</script>

<style scoped>
.text-color {
    color: #7b1fa2;
}
</style>
